import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PersonalBasicInfo from '../../../widgets/personalBasicInfo/PersonalBasicInfo'
import AddressWork from '../../../widgets/address/addressWork/AddressWork'
import AddressCard from '../../../widgets/address/addressCard/AddressCard'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import AddressDeliveryDocument from '../../../widgets/address/addressDeliveryDocument/AddressDeliveryDocument'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import { Panel, Checkbox, Modal, Button, Row, Message } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import {
  getSchemaProposalResponsinatorBasicInfoSubproject,
  updateSchemaProposalResponsinatorBasicInfoSubproject,
} from '../../../redux/actions/proposalResponsinator'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getSchemaSidebar, getSchemaSubProjectSidebar } from '../../../redux/actions/sidebar'
import CurrentAddress from '../../../widgets/address/currentAddress/CurrentAddress'

export default function ProposalResponsibleManBasicInfo() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [addressWork, setAddressWork] = useState()
  const [addressCard, setAddressCard] = useState()
  const [showConfirm, setShowConfirm] = useState(false)
  // const [disabledEdit, setDisabledEdit] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [error, setError] = useState()
  const [isError, setIsError] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const dispatch = useDispatch()

  const [sameGranteeInfo, setSameGranteeInfo] = useState()
  const type = 'responsinator'

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaProposalResponsinatorBasicInfoSubproject(projectId)
      //console.log('getSchemaProposalResponsinatorBasicInfo', _schema)
      let sameGrantee = _schema?.forms?.responsinatorInfo?.sameGrantee.value
      setSameGranteeInfo(sameGrantee)
      // setDisabledEdit(sameGrantee)
      setAddressWork(initAddress(_schema?.forms?.currentAddress))
      setAddressCard(initAddress(_schema?.forms?.idCardAddress))
      setSchema(_schema)
      setIsEditWidget({
        persomal: _schema.forms?.persomal?.id ? false : true,
        currentAddress: _schema.forms?.currentAddress?.id ? false : true,
        idCardAddress: _schema.forms?.idCardAddress?.id ? false : true,
        documentAddress: _schema.forms?.documentAddress?.id ? false : true,
        officeLocation: _schema.forms?.officeLocation?.id ? false : true,
      })

      setShowEditAll(
        !_schema.forms?.persomal?.disabled &&
          !_schema.forms?.currentAddress?.disabled &&
          !_schema.forms?.idCardAddress?.disabled &&
          !_schema.forms?.documentAddress?.disabled &&
          !_schema.forms?.officeLocation?.disabled
      )
    } catch (e) {
      console.log('e', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnSubmitAddressWork = (value) => {
    setAddressWork(value)
  }

  const handleOnSubmitAddressCard = (value) => {
    setAddressCard(value)
  }

  const handleSaveSameGranteeInfo = async () => {
    let request = {
      projectVersionId: projectId,
      sameGrantee: sameGranteeInfo,
    }
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const _schema = await updateSchemaProposalResponsinatorBasicInfoSubproject(projectId, request)
      // console.log('updateSchemaProposalResponsinatorBasicInfo', _schema)
      setSameGranteeInfo(_schema?.forms?.responsinatorInfo?.sameGrantee.value)
      setSchema(_schema)
      // setDisabledEdit(sameGranteeInfo)
      // setIsEditAll(false)
      setShowEditAll(!sameGranteeInfo)
      setIsEditAll(!sameGranteeInfo, isEditWidget, setIsEditWidget)
      setShowConfirm(false)
      await dispatch(getSchemaSubProjectSidebar(projectId))
    } catch (e) {
      console.log('e', e)
      setIsError(true)
    }
    setShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const initAddress = (address) => {
    return {
      buildingName: address?.buildingName?.value,
      roomNumber: address?.roomNumber?.value,
      houseNumber: address?.houseNumber?.value,
      villageNumber: address?.villageNumber?.value,
      lane: address?.lane?.value,
      villageName: address?.villageName?.value,
      road: address?.road?.value,
      location: address?.location?.value,
      telephone: address?.telephone?.value,
      mobile: address?.mobile?.value,
      fax: address?.fax?.value,
      email: address?.email?.value,
    }
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSubProject>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
        />
      )}

      {schema?.forms?.responsinatorInfo && (
        <>
          <Panel header={schema.forms.responsinatorInfo.header} shaded>
            <CustomIconMessageInfo content={schema.forms.responsinatorInfo.messageInfo} />
            <Checkbox
              defaultChecked={sameGranteeInfo}
              disabled={schema?.forms?.responsinatorInfo?.disabled}
              onChange={(value, checked) => {
                setSameGranteeInfo(checked)
              }}
            >
              {schema.forms.responsinatorInfo.sameGrantee.label}
            </Checkbox>
            {!schema?.forms?.responsinatorInfo?.disabled && (
              <>
                <hr />
                {isError && (
                  <Row style={{ marginBottom: 10 }}>
                    <Message
                      showIcon
                      type="error"
                      description={
                        'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
                      }
                    />
                  </Row>
                )}
                <SaveButton
                  onClick={() => setShowConfirm(true)}
                  disabled={schema.forms.responsinatorInfo.sameGrantee.value == sameGranteeInfo}
                ></SaveButton>
              </>
            )}
          </Panel>
          <br />
        </>
      )}

      {/* ข้อมูลเบื้องต้นบุคคลธรรมดา */}
      {schema?.forms?.persomal && (
        <>
          <PersonalBasicInfo
            showCommandButton={!schema.forms.persomal.disabled}
            honorificOptions={schema.forms.honorificOptions}
            isEdit={isEditWidget.persomal && !schema.forms.persomal.disabled}
            onChangeIsEdit={(_isEdit) => handleOnChangeIsEdit('persomal', _isEdit, setIsEditWidget)}
            schema={schema.forms.persomal}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ปัจจุบัน (บุคคลธรรมดา) */}
      {schema?.forms?.currentAddress && (
        <>
          <CurrentAddress
            showCommandButton={!schema.forms.currentAddress.disabled}
            schema={schema.forms.currentAddress}
            isEdit={isEditWidget.currentAddress && !schema.forms.currentAddress.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('currentAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={handleOnSubmitAddressWork}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ตามบัตรประจำตัวประชาชน (บุคคลธรรมดา)*/}
      {schema?.forms?.idCardAddress && (
        <>
          <AddressCard
            showCommandButton={!schema.forms.idCardAddress.disabled}
            isEdit={isEditWidget.idCardAddress && !schema.forms.idCardAddress.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('idCardAddress', _isEdit, setIsEditWidget)
            }
            handleOnSubmit={handleOnSubmitAddressCard}
            schema={schema.forms.idCardAddress}
            addressWork={addressWork}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* ที่อยู่ที่จัดส่งเอกสาร*/}
      {schema?.forms?.documentAddress && (
        <>
          <AddressDeliveryDocument
            showCommandButton={!schema.forms.documentAddress.disabled}
            schema={schema.forms.documentAddress}
            isEdit={isEditWidget.documentAddress && !schema.forms.documentAddress.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('documentAddress', _isEdit, setIsEditWidget)
            }
            addressWork={addressWork}
            addressCard={addressCard}
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      {/* ที่อยู่สถานที่ทำงาน (บุคคลธรรมดา)*/}
      {schema?.forms?.officeLocation && (
        <>
          <AddressWork
            showCommandButton={!schema.forms.officeLocation.disabled}
            schema={schema.forms.officeLocation}
            isEdit={isEditWidget.officeLocation && !schema.forms.officeLocation.disabled}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('officeLocation', _isEdit, setIsEditWidget)
            }
            type={type}
            isSubProject={true}
          />
          <br />
        </>
      )}

      <Modal
        size="sm"
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        style={{ marginTop: '5%' }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการแก้ไข</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>ข้อมูลผู้รับผิดชอบโครงการทั้งหมด จะถูกเปลี่ยนเป็นข้อมูลเหมือนของผู้รับทุนทั้งหมด</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => handleSaveSameGranteeInfo()} appearance="primary">
            ยืนยัน
          </Button>
          <Button onClick={() => setShowConfirm(false)} appearance="subtle">
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </SidebarProposal>
  )
}
